import { useEffect, useMemo, useState } from "react";

export default function Countdown() {
  const weddingDate = useMemo(() => new Date("2026-11-22T00:00:00"), []);

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const diff = weddingDate.getTime() - now.getTime();

      if (diff <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
        });
        return;
      }

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
      });
    };

    updateCountdown();

    const timer = setInterval(updateCountdown, 60000);

    return () => clearInterval(timer);
  }, [weddingDate]);

  return (
    <div className="countdown">
      <div>
        <span>{timeLeft.days}</span>
        <p>Days</p>
      </div>

      <div>
        <span>{timeLeft.hours}</span>
        <p>Hours</p>
      </div>

      <div>
        <span>{timeLeft.minutes}</span>
        <p>Minutes</p>
      </div>
    </div>
  );
}